export default __webpack_public_path__ + "static/vasivasireddy-56b7779eac934867d0ce8d2ea6a1cf31.png";